import { Modal } from "reactstrap";
import styles from "./PcAccessModal.module.scss";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { IoMdClose as CloseIcon } from 'react-icons/io'
import PcAccess from "./PcAccess";

type Props = {
    isOpen: boolean;
    closeForm: () => void;
}

const PcAccessModal = ({ isOpen, closeForm }: Props) => {

    return (
        <Modal size="md" centered isOpen={isOpen} toggle={() => closeForm()}>
            <div className={styles.accessModalRootContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.title}>
                        Update Access
                    </div>
                    <div className={styles.actionButtonContainer}>
                        <MeritoButton onlyIcon={true} icon={<CloseIcon />} type="secondary-1" onClick={() => closeForm()} />
                    </div>
                </div>
                <PcAccess closeForm={closeForm} showInModal={true} />
            </div>
        </Modal>
    );
}

export default PcAccessModal